import AniLink from "gatsby-plugin-transition-link/AniLink"
import React from "react"
import btnStyles from "../styles/button.module.scss"
// import Button from '../components/Button'
import grant from "../images/grant-headshot.jpg"
import powerDown from "../images/power-down.jpg"
import styles from "../styles/testimonials.module.scss"
import toni from "../images/toni-headshot.jpg"

function Testimonials(props) {
  return (
    <div className={styles.testimonials_inner}>
      <h2 class="orange">HERE IS HOW YOU COULD FEEL IN 7 WEEKS</h2>
      <div className={styles.testimonials_quotes}>
        <div className={styles.testimonials_quotes_1}>
          <img
            src={grant}
            loading="lazy"
            alt="grant korgan"
            className={styles.testimonials_quotes_img}
          />
          <p>
            “The seven week program showed me the tools that had been right in
            front of my face for decades but I was unable to see them. In a
            short amount of time I had actionable items to execute on, and I had
            clarity for the things that were holding me back. Life is simple; we
            have a way of complicating it and Shawna has a gift of showing us
            the tools to illuminate the simplicity our souls already know.”
          </p>
          <p className={styles.testimonials_quotes_name}>- Grant Korgan</p>
        </div>
        <div className={styles.testimonials_quotes_2}>
          <img
            src={toni}
            loading="lazy"
            alt="grant korgan"
            className={styles.testimonials_quotes_img}
          />
          <p>
            "Shawna’s process is incredible, because she takes you on a journey.
            First, you are engaging  in a physical class that immediately
            transports you to a place where you HAVE to be present. Then, the
            thought-coaching comes into play—and your presence of mind enables
            you to fully absorb the tools of empowerment that Shawna so
            genuinely provides."
          </p>
          <p className={styles.testimonials_quotes_name}>- Antonia Polan</p>
        </div>
      </div>
    </div>
  )
}

export default Testimonials
